"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.languageSelector = exports.LanguageSelector = void 0;
class LanguageSelector {
    constructor() {
        this.texts = require('../languages/en/en.json');
        this.selectedLanguage = 'en';
    }
    setLanguage(language) {
        this.selectedLanguage = language;
        switch (language) {
            case 'zh':
                this.texts = require('../languages/zh/zh.json');
                break;
            default:
                this.texts = require('../languages/en/en.json');
        }
        return this.texts;
    }
    getText(ref) {
        return this.texts[ref] || ref;
    }
    getSoftwareUpdateInfo(update) {
        if (this.selectedLanguage === 'en') {
            return update.Revision_Info;
        }
        else {
            const revisionInfoInLangauge = update['Revision_Info_' + this.selectedLanguage];
            return revisionInfoInLangauge
                ? revisionInfoInLangauge
                : update.Revision_Info;
        }
    }
    getUserGripInfo(info) {
        if (this.selectedLanguage === 'en') {
            return info.Info;
        }
        else {
            const revisionInfoInLangauge = info['Info_' + this.selectedLanguage];
            return revisionInfoInLangauge ? revisionInfoInLangauge : info.Info;
        }
    }
    getAlert(alertName) {
        const alert = this.texts['alerts'][alertName];
        return { title: alert.title, message: alert.message };
    }
}
exports.LanguageSelector = LanguageSelector;
const languageSelector = new LanguageSelector();
exports.languageSelector = languageSelector;
